<template>
    <HeaderContent title="Driver & Guide" />
    <ActionContent
        ctaText="Staff"
        :filterDate="false"
        :filterModal="false"
        @action="modal = !modal"
        @search-query="searchData"
    />
    <AdminStatistics title="Driver & Guide Statistics" :data="statistics" />
    <DriverGuideForm
        :modal="modal"
        :selectedData="selectedData"
        @update:modal="updateModal"
        @addOrUpdate="getAll"
    ></DriverGuideForm>
    <DataTable
        :data="driverGuideList"
        :header="headers"
        :custom-actions="customActions"
    >
        <template #cell(fullname)="data">
            <div class="d-flex align-items-center justify-content-start">
                <span 
                    class="d-inline-block rounded-circle me-2" 
                    :style="`width: 12px; height: 12px; background-color: ${data.item.label_color || '#FFFFFF'}; border: 1px solid #dee2e6;`"
                    :title="data.item.label_color"
                ></span>
                {{ data.item.fullname }}
            </div>
        </template>
    </DataTable>
</template>

<script setup>
import axios from "axios";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import DriverGuideForm from "./DriverGuideForm.vue";
import DataTable from "@/components/DataTable.vue";
import AdminStatistics from "@/components/StatisticData.vue";
import iconUser from "../../../public/icons/users-alt.svg";
import { ref, onMounted, inject } from "vue";
import { useLoading } from "vue-loading-overlay";
import { useAuthStore } from "@/store/auth.js";
import { useToast } from "vue-toastification";

const auth = useAuthStore();
const $loading = useLoading();
let selectedData = ref({});
const swal = inject("$swal");
const toast = useToast();
const modal = ref(false);

const statistics = ref([]);
const updateStatistics = (summary) => {
    statistics.value = [
        {
            label: "Total",
            key: "Driver",
            value: summary.driver ?? 0,
            color: "info",
            icon: iconUser,
        },
        {
            label: "Total",
            key: "Guide",
            value: summary.guide ?? 0,
            color: "info",
            icon: iconUser,
        },
    ];
};

const headers = ref([
    { key: "no", label: "No", sortable: true },
    { key: "fullname", label: "Name", sortable: true },
    { key: "position", label: "Position", sortable: true },
    { key: "phone", label: "Contact", sortable: true },
    { key: "address", label: "Address", sortable: true },
    { key: "status", label: "Status", sortable: false },
    { key: "action", label: "Actions" },
]);
const customActions = ref([
    // {
    //     label: (item) => (item.status == "Active" ? "Deactivate" : "Activate"),
    //     icon: (item) =>
    //         item.status == "Active" ? "fas fa-user-slash" : "fas fa-user-check",
    //     variant: (item) => (item.status == "Active" ? "secondary" : "primary"),
    //     action: (item) => {
    //         console.log("Extra charge action clicked for:", item);
    //         // Implement your extra charge logic here
    //     },
    // },

    {
        label: "Edit",
        variant: "success",
        icon: "fas fa-edit",
        action: (item) => {
            selectedData.value = item;
            modal.value = true;
        },
    },
    {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
            swal({
                title: "Confirm",
                text: "Are you sure to delete this data?",
                showCancelButton: true,
                confirmButtonText: "Yes, delete!",
                cancelButtonText: "Cancel",
                customClass: {
                    popup: "rounded",
                    confirmButton: "btn btn-danger me-2",
                    cancelButton: "btn btn-secondary",
                },
                buttonsStyling: false,
            }).then((confirm) => {
                if (confirm.value) {
                    deleteData(item.uuid);
                } else {
                    swal.close();
                }
            });
        },
    },
]);

const searchData = async (search) => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        await getAll(search);
    } finally {
        loader.hide();
    }
};

const updateModal = (newValue) => {
    selectedData.value = {};
    modal.value = newValue;
};

let driverGuideList = ref([]);

const getAll = async (search = "") => {
    const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/staff`,
        {
            params: {
                search: search,
            },
            headers: {
                "Content-type": "application/json",
                Authorization: "Bearer " + auth._token,
            },
        }
    );

    const res = response.data;

    if (res.status) {
        driverGuideList.value = res.data;
        updateStatistics(res.summary);
    }
};

const deleteData = async (uuid) => {
    if (uuid) {
        toast.clear();
        const loader = $loading.show({
            color: "#009689",
            loader: "bars",
            zIndex: 999999,
        });

        try {
            const response = await axios.delete(
                `${process.env.VUE_APP_API_URL}/staff/delete/${uuid}`,
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                toast.success(res.message);
                getAll();
            }
        } finally {
            loader.hide();
        }
    }
};

onMounted(async () => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        await getAll();
    } finally {
        loader.hide();
    }
});
</script>
